<template>
  <div>
    <px-view-header title="Cotações de frete" :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-cotacao-frete-header :on-click-refresh="onClickRefresh"
                                     :is-comprador="true"
                                     @change="onChangeFilter"/>
      <lista-cotacao-frete :cotacoes="cotacoes"
                           :loading="loading"
                           :on-change-options="onChangeOptions"
                           :options-list="optionsList"
                           @update="onClickRefresh"/>
    </div>
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import CotacoesFreteService from './cotacao-frete-service';
import ListaCotacaoFrete from './ListaCotacaoFrete.vue';
import ListagemCotacaoFreteHeader from './ListagemCotacaoFreteHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    isComprador: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cotacoes: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        { text: 'Cotações de fretes' },
      ],
      optionsList: {},
    };
  },
  methods: {
    buildSearchFilter(filters) {
      const filter = [];
      if (filters.searchText) {
        filter.push(`transportadora like "%${filters.searchText.toLowerCase()}%" or identificador like "%${filters.searchText.toLowerCase()}%"`);
      }
      if (filters.selectedStatus && filters.selectedStatus.value) {
        filter.push(`situacao in ('${filters.selectedStatus.value.join('\',\'')}')`);
      }

      if (!filter.length) {
        return '';
      }

      return filter.join(' and ');
    },
    onChangeFilter(filters) {
      this.listOptions.filter = this.buildSearchFilter(filters);
      this.resetPage();
      this.getCotacoes();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCotacoes();
    },
    onClickRefresh() {
      this.getCotacoes();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCotacoes() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CotacoesFreteService.getCotacoes({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.cotacoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    ListaCotacaoFrete,
    ListagemCotacaoFreteHeader,
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
